import React from "react";
import Cookies from "universal-cookie";
import { NineCellLoading } from 'react-loadingg';

import '../pages/landingPage/style.css';
import createDatabaseFromUser from '../services/createDatabaseFromUser';
import addClientUser from "../services/addClientUser";

import sendMail from "../services/sendMainEmail";
import { demoEmailBody } from "../utils/consts";
import translateString from "../utils/Locales";

import countries from '../utils/countries.json';
import SelectInput from "./SelectInput";

const cookies = new Cookies();
var username = '';
var token = '';

let t = translateString;

export default class DemoCreationWidget extends React.Component {
    constructor(props) {
        super(props);

        username = cookies.get('site_username', { path: '/' });
        token = cookies.get('site_token', { path: '/' });

        this.selectRef = React.createRef();

        this.state = {
            isWorking: true,
            error: false,
            clientAddress: '', 
            clientPhone: '', 
            clientCity: '', 
            clientProvincia: '', 
            clientCAP: '',
            defError: false,
            index: 1,
            isEndingSubscription: props.endingSub ? props.endingSub : false,
            stato: { value: 'nil', label: t('seleziona')}, 
        };
    }

    componentDidMount() {

        this.countriesArray = [];
        countries.forEach((country) => {
            this.countriesArray.push({ value: country.code, label: country.name });
        });
        this.setState({ isWorking: false });
    }

    getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }

    async createDb() {
        let res = await createDatabaseFromUser(username, token, this.props.cliente.clear_password, this.props.cliente.ragioneSociale, '', this.dbName, this.state.clientAddress, this.state.clientCity, this.state.clientProvincia, this.state.clientCAP, this.props.cliente.email, this.state.clientPhone);
        if (res != null) {
            if (res.result !== null && res.result === 'KO') {
                this.dbName += this.state.index;
                this.setState({ index: this.state.index + 1 });
                await this.createDb();
            } else {
                let res1 = await addClientUser(username, token, this.props.cliente.ragioneSociale, this.state.clientAddress, this.state.clientCity, this.state.clientProvincia, this.state.clientCAP, this.state.stato.value, this.props.cliente.email, this.state.clientPhone, '', this.dbName);
                if (res1.result == 'ok') {
                    //setUserProperties(analytics, { site_user_logged: true, main_user: false, user_registered_demo: true });
                    cookies.set('username', username, { path: '/' });

                    await sendMail(this.props.cliente.email, this.props.cliente.ragioneSociale, t('benvenuto_1'), demoEmailBody(this.props.cliente.ragioneSociale, this.dbName));

                    if (res.user != null) {
                        cookies.set('token', res.token, { path: '/' });
                        cookies.set('db', this.dbName, { path: '/' });
                        window.location.href = this.dbName + '#/login?username=' + username + '&token=' + res.token;
                    } else {
                        window.location.href = this.dbName;
                    }
                } else {
                    this.setState({ isWorking: false, defError: true });
                    setTimeout(() => {
                        this.setState({ defError: false });
                    }, 3000);
                }
            }
        }
    }

    async createDemo() {
        let special = ['[','!','"','`','#','%','&',',',':',';','<','>','=','@','{','}','~','(',')','*','+','/','?','[',']','^','|',']']
        if (this.state.clientAddress != '' && this.state.clientCity != '' && this.state.clientProvincia != '' && this.state.clientCAP != '' && this.state.clientPhone != '' && this.state.stato.value !== 'nil') {
            this.setState({ isWorking: true });

            this.dbName = this.props.cliente.ragioneSociale.toLowerCase().split(' ').join('');
            this.dbName = this.dbName.split('.').join('');
            this.dbName = this.dbName.split("'").join('');
            this.dbName = this.dbName.split("$").join('');
            this.dbName = this.dbName.split("\\").join('');
            special.forEach(element => {
                this.dbName = this.dbName.split(element).join('');
            })
            if (this.dbName === "") {
                alert("Si è verificato un errore, per favore contattare l'assistenza clienti")
                this.setState({ isWorking: false });
                return
            }
            await this.createDb();
        } else {
            this.setState({ error: true });
            setTimeout(() => {
                this.setState({ error: false });
            }, 3000);
        }
    }

    render() {

        return(
            <div style={backView}>
                <div style={mainView}>
                    { this.state.isWorking ? <NineCellLoading /> : (
                        <>
                            <div style={{ textAlign: 'end' }}>
                                <img alt="" src={ require('../images/close_icon.png') } style={{ alignSelf: 'flex-end', width: 30, height: 30, marginTop: 30, marginRight: 30, cursor: 'pointer', visibility: this.state.isEndingSubscription ? 'hidden' : 'visible' }} onClick={this.props.onCancel} />
                            </div>
                            <p style={{ textAlign: 'center', width: '100%', marginTop: '-10px', fontSize: 24, fontFamily: 'Teko', fontWeight: 'bold' }}>{t('attiva_profilo')}</p>
                            <p style={{ textAlign: 'center', width: '100%', marginTop: '-15px', marginBottom: '15px', fontSize: 14, fontFamily: 'Teko' }}>{t('ultimi_passi')}</p>
                            <br/><div style={{ display: 'flex', width: '90%', marginLeft: '7%' }}>
                                <div style={{ flex: 1  }}>
                                    <input type='text' name='Ragione Sociale' style={{ width: '90%' }} readOnly={true} value={this.props.cliente.ragioneSociale} className="inputCustom" /><br/>
                                    <input type='text' name='Indirizzo' style={{ width: '90%', marginTop: 7}} placeholder={t('indirizzo_istituto')} value={this.props.clientAddress} onChange={(event) => this.setState({ clientAddress: event.target.value })} className="inputCustom" /><br/>
                                    <input type='text' name='Città' style={{ width: '90%', marginTop: 7}} value={this.props.clientCity} placeholder={t('citta')} onChange={(event) => this.setState({ clientCity: event.target.value })} className="inputCustom" /><br/>
                                    <input type='text' name='Provincia' style={{ width: '90%', marginTop: 7}} value={this.props.clientProvincia} placeholder={t('stato_provincia')} onChange={(event) => this.setState({ clientProvincia: event.target.value })} className="inputCustom" /><br/>
                                    <input type='text' name='Cap' style={{ width: '90%', marginTop: 7}} value={this.props.clientCAP} placeholder={t('codice_postale')} onChange={(event) => this.setState({ clientCAP: event.target.value })} className="inputCustom" />
                                </div>
                                <div style={{ flex: 1, marginTop: -15 }}>
                                    <SelectInput 
                                        ref={this.selectRef}
                                        value={this.state.stato} 
                                        name={t('stato_p')} 
                                        hidable={false}
                                        options={this.countriesArray} 
                                        onChange={(option) => 
                                            this.setState({ stato: option })} 
                                    />
                                    <input type='text' name='Email' style={{ width: '90%' }} readOnly={true} value={this.props.cliente.email} className="inputCustom" /><br/>
                                    <input type='text' name='Telefono' style={{ width: '90%', marginTop: 7}} value={this.state.clientPhone} placeholder={t('telefono')} onChange={(event) => this.setState({ clientPhone: event.target.value })} className="inputCustom" />
                                    { this.state.error && <p style={{ textAlign: 'center', color: 'red', fontFamily: 'Teko', marginTop: 20, marginRight: '7%', fontSize: 14, fontWeight: 'bold' }}>{t('verifica_dati')}</p> }
                                    { this.state.defError && <p style={{ textAlign: 'center', color: 'red', fontFamily: 'Teko', marginTop: 20, marginRight: '7%', fontSize: 14, fontWeight: 'bold' }}>{t('errore_imprevisto')}</p> }
                                </div>
                            </div>
                            <div style={{textAlign: 'center', marginTop: 30}}>
                                <div className="btn btn-primary" onClick={() => this.createDemo()}>{t('crea')}</div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const backView = {
    width: '100%', 
    height: '100%', 
    backgroundColor: '#00000033', 
    display: 'block',
    position: 'absolute', 
    top: 0, 
    bottom: 0, 
    right: 0, 
    left: 0,
}

const mainView = {
    width: '50%', 
    maxHeight: '70%', 
    minHeight: '75%',
    height: '75%',
    overflowY: 'scroll',
    overflowX: 'hidden',
    position: 'abolsute',
    marginLeft: '25%', 
    marginTop: '100px', 
    paddingBottom: '3%',
    backgroundColor: 'white', 
    borderRadius: '10px', 
    boxShadow: '0px 2px 10px darkgrey',
}